<template>
    <v-data-table 
    :loading="loading"
    :search="search"
    />
</template>

<script>
// ui 컴포넌트 import


// 요소 컴포넌트 import


// api & back import


export default {
    components: {
        // ui 컴포넌트

        // 요소 컴포넌트

    },
    data() {
        return {
            
        };
    },
    methods: {
                
    },
}
</script>